/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BeneficiaryChangeAliases {
  ACTION_0 = 'action-0',
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_FIELD_SITUACAO = 'autocomplete-field-situacao',
  AUTOCOMPLETE_SITUACAO_TRAB = 'autocomplete-situacao-trab',
  AUTOCOMPLETE_SUB_ESTIPULANTE = 'autocomplete-sub-estipulante',
  BENEFICIARY_AUTOCOMPLETE = 'beneficiary-autocomplete',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATA_TABLE_BENEFICIARY_CHANGE = 'data-table-beneficiary-change',
  DATA_TABLE_COLUMN_BENEFICIARY = 'data-table-column-beneficiary',
  DATA_TABLE_COLUMN_CARD = 'data-table-column-card',
  DATA_TABLE_COLUMN_END_DATE = 'data-table-column-end-date',
  DATA_TABLE_COLUMN_HOLDER = 'data-table-column-holder',
  DATA_TABLE_COLUMN_HOLDER_STATUS = 'data-table-column-holder-status',
  DATA_TABLE_COLUMN_MENU = 'data-table-column-menu',
  DATA_TABLE_COLUMN_SIGNING_DATE = 'data-table-column-signing-date',
  DATA_TABLE_COLUMN_SITUATION = 'data-table-column-situation',
  DECK_0 = 'deck-0',
  FETCH_BENEFICIARY = 'fetch-beneficiary',
  FETCH_BENEFICIARY_CHANGE = 'fetch-beneficiary-change',
  FETCH_FIELD_SITUACAO = 'fetch-field-situacao',
  FETCH_SITUACAO_TRAB = 'fetch-situacao-trab',
  FETCH_SUB_ESTIPULANTE = 'fetch-sub-estipulante',
  FETCH_TIPO_DATA = 'fetch-tipo-data',
  FIELD_BENEFICIARY = 'field-beneficiary',
  FIELD_SITUACAO = 'field-situacao',
  FIELD_SITUACAO_TRAB = 'field-situacao-trab',
  FIELD_SUB_ESTIPULANTE = 'field-sub-estipulante',
  FIELD_TIPO_DATA = 'field-tipo-data',
  FILTER_BENEFICIARY_CHANGE = 'filter-beneficiary-change',
  FILTERED_LIST_0 = 'filtered-list-0',
  FIRST_AT_DATE_FIELD = 'first-at-date-field',
  FIRST_AT_FIELD = 'first-at-field',
  HPMS_BENEFICIARY_CHANGE_CARD = 'hpms-beneficiary-change-card',
  LAST_ACCESS_AT_DATE_FIELD = 'last-access-at-date-field',
  LAST_ACCESS_AT_FIELD = 'last-access-at-field',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_BENEFICIARY_CHANGE = 'layout-beneficiary-change',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_2 = 'mapper-2',
  MAPPER_3 = 'mapper-3',
  MAPPER_4 = 'mapper-4',
  MAPPER_FIELD_SITUACAO = 'mapper-field-situacao',
  MAPPER_SITUACAO_TRAB = 'mapper-situacao-trab',
  MAPPER_TIPO_DATA = 'mapper-tipo-data',
  MEDIA_QUERY_REPONSIVO = 'media-query-reponsivo',
  MEDIA_QUERY_TABLE = 'media-query-table',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_FIELD_SITUACAO = 'text-field-situacao',
  TEXT_SITUACAO_TRAB = 'text-situacao-trab',
}
export { BeneficiaryChangeAliases };
